<script setup lang="ts">
// Neutral landing. Orients the user to the three team sections (Support / PE / Dev); each card links
// to that team's overview page. The monitor lives at /profile-generation (ProfileGenerationView).
import { computed } from "vue";
import { keycloak } from "../main.js";
import { getSections } from "../config/sections";

const authenticated = computed(() => keycloak.authenticated || false);
const sections = getSections();
</script>

<template>
    <div>
        <div class="card" v-if="!authenticated">
            <h2>Welcome, please log in to use the admin platform.</h2>
            <p>After logging in you'll find the tools grouped by team: Support, PE and Dev.</p>
        </div>
        <div v-else class="my-8">
            <h1 class="page-title mb-1">persolog Admin</h1>
            <p class="text-content-muted mt-0 mb-6">Tools grouped by team — pick a section.</p>
            <div class="grid grid-cols-12 gap-4">
                <div v-for="section in sections" :key="section.key" class="col-span-12 md:col-span-4">
                    <Card class="h-full">
                        <template #title>
                            <i :class="section.icon" class="mr-2" />{{ section.title }}
                        </template>
                        <template #content>
                            <p class="mt-0 text-content-muted">{{ section.description }}</p>
                        </template>
                        <template #footer>
                            <router-link :to="section.to" class="no-underline">
                                <Button :label="`Open ${section.title}`" icon="pi pi-arrow-right" icon-pos="right" outlined />
                            </router-link>
                        </template>
                    </Card>
                </div>
            </div>
        </div>
    </div>
</template>
